var App = App || {};

App.Testimonials = (function ($) {
    "use strict";

    var $slider;
    var slideCount;

    function init() {
      
        $slider = $('.component-testimonials-wrapper');
        slideCount = $slider.find('.testimonials-col').length;
        if (slideCount > 1) {
            $slider.on('init reInit afterChange', function () {
                setSlideHeight();
            });

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                fade: true,
                speed: 600,
                cssEase: 'linear',
                adaptiveHeight: false,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fa-solid fa-arrow-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fa-solid fa-arrow-right"></i></button>',
            });
        }

        setSlideHeight();
      
        $(window).on('resize', function () {
            setTimeout(setSlideHeight, 200);
        });
    }

    function setSlideHeight() {
        var maxHeight = 0;

        $('.testimonials-col').each(function () {
            $(this).css('height', 'auto'); 
            var slideHeight = $(this).outerHeight();
            if (slideHeight > maxHeight) {
                maxHeight = slideHeight;
            }
        });

        $('.testimonials-col').css('height', maxHeight + 'px');
    }

    return {
        init: init
    }
})(jQuery);

$(function () {
    App.Testimonials.init();
});